/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "बदू - नये लोगों से मिलें, चैट, मेल-जोल करें",
      "ग़लत फोन क्रमांक",
      "Get the app",
      "Apple की मदद से जारी रखें",
      "Facebook का इस्तेमाल करके जारी रखें",
      "Google का इस्तेमाल करके जारी रखें",
      "लॉग इन करें",
      "साइन अप करें",
      "जारी रखने के लिए, कृपया इनपुट फ़ील्ड में दिखाए गए वर्ण डालें.",
      "जारी रखें",
      "वर्ण डालें",
      "सुरक्षा जांच",
      "फिर से लोड करें",
      "ऐसा नया पासवर्ड बनाएं जिसे याद रखना आसान हो.",
      "अपडेट करें",
      "पासवर्ड की पुष्टि करें",
      "पासवर्ड में कम से कम {{num}} [[characters:num]] होने चाहिए",
      "पासवर्ड",
      "नया पासवर्ड बनाएं",
      "बदू - The Blog",
      "नौकरी",
      "चैट",
      "शहर",
      "कुकी मैनेज करें",
      "Copyright © 2006 – present. Bumble. सभी अधिकार सुरक्षित हैं.",
      "Apple और Apple का लोगो Apple Inc के ट्रेडमार्क हैं.{{__EOL__}}Google Play, Google LLC का ट्रेडमार्क है.",
      "डाउनलोड करें",
      "Facebook",
      "हमें फ़ॉलो करें",
      "सहायता केंद्र",
      "Instagram",
      "भाषा",
      "LinkedIn",
      "जानकारी",
      "बदू, Bumble Inc का हिस्सा है.",
      "निजता नीति",
      "सुरक्षा केंद्र",
      "साइटमैप",
      "मॉडर्न स्लेवरी ऐक्ट स्टेटमेंट",
      "नियम और शर्तें",
      "Twitter",
      "ईमेल पता या फ़ोन नंबर डालें और हम आपको नया पासवर्ड बनाने के निर्देश भेजेंगे.",
      "नया पासवर्ड बनाएं",
      "अपना ईमेल पता या फ़ोन नंबर डालें",
      "पासवर्ड याद नहीं है",
      "मॉडल का इस्तेमाल सिर्फ़ तस्वीरों के लिए किया गया है",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of बदू’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to बदू",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At बदू, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "बदू has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "मैच मिलने का इंतज़ार करने की कोई ज़रूरत नहीं है.{{__EOL__}}{{__EOL__}}लोगों से चैट करें और सीधे जैसा चाहें वैसा रिश्ता बनाने की शुरुआत करें. आपको पता है कि यहां आप एक दूसरे के बारे में बेहतर तरीके से जान सकते हैं.",
      "अभी चैट करने के लिए तैयार है?",
      "साइन अप करने पर, यह माना जाएगा कि आप <a class=\"link\" href=\"{{terms_url}}\">हमारे नियमों और शर्तों</a> से सहमत हैं. हमारी <a class=\"link\" href=\"{{privacy_url}}\">निजता नीति</a> में जानें कि हम आपके डेटा का इस्तेमाल कैसे करते हैं.",
      "शानदार डेटिंग करने के लिए हम आपकी<br />जानकारी देने में आपकी मदद कर रहे हैं.",
      "यहां भरोसे के साथ डेटिंग करें",
      "या",
      "क्या आपके पास पहले से एक खाता है?",
      "अपने ईमेल पते या फ़ोन नंबर से साइन अप करें",
      "डेटिंग से अपना मनचाहा साथी ढूंढें.{{__EOL__}}माफ़ी मांगने की कोई ज़रूरत नहीं है.",
      "आपको सिर्फ़ चैट करनी है? ठीक है.{{__EOL__}}आपको जीवनसाथी चाहिए? बहुत बढ़िया.{{__EOL__}}{{__EOL__}}और अगर आपको इनमें से कुछ नहीं करना, तो भी ठीक है.",
      "डेट करने के लिए",
      "रिलेशनशिप के लिए तैयार हूं",
      "चैट करने के लिए तैयार",
      "ऐसे लोगों से मिलें जिनकी दिलचस्पी आप जैसी हो.",
      "{{name}}, {{age}}",
      "आपकी सुरक्षा हमारे लिए सबसे अहम है.",
      "हमारे सुरक्षा केंद्र पर जाएं जो एक जानकारी का हब है. यहां जाकर, आपको सभी ज़रूरी जानकारी मिलेगी, जो डेटिंग करने में आपकी मदद करेगी.",
      "हमारे सुरक्षा केंद्र पर जाएं",
      "हमेशा से सुरक्षा<br/>हमारी प्राथमिकता रही है.",
      "पहले ही पल से मुझे लग रहा था कि इससे काम बन जाएगा...",
      "शुरुआत में, मुझे किसी रिश्ते में नहीं बंधना था...",
      "किसी व्यक्ति को बदू ऐप्लिकेशन इस्तेमाल करने के बारे में सबसे बढ़िया सलाह यह है कि वे अपने बारे में सच बोलें...",
      "बदू की सफलता से जुड़ी स्टोरी",
      "सफलता से जुड़ी अन्य स्टोरी पढ़ें",
      "{{num}}__CUT__रेटिंग",
      "Apple App Store",
      "हम पर भरोसा रखें. हमने साल 2006 से करोड़ों लोगों को मिलाया है.",
      "{{num}} मिलियन+__CUT__डाउनलोड",
      "{{num}} मिलियन+",
      "Google Play Store",
      "हमें पता है कि हम क्या कर रहे हैं.",
      "अपने ईमेल पते या फ़ोन नंबर से लॉग इन करें",
      "अपना पासवर्ड डालें",
      "क्या पासवर्ड याद नहीं है?",
      "साइन अप करें",
      "क्या आपके पास खाता नहीं है?",
      "लॉग इन करें",
      "साइन अप करें"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "अक्षरों",
                  "अक्षरों"
            ],
            "singular": [
                  "अक्षर",
                  "अक्षर"
            ]
      },
      "day": {
            "plural": [
                  "दिन",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनटों"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
